import { Directive, inject } from '@angular/core';
import { DECLARATIVE_MAP_IMPLEMENTATION, ElementIdentifier } from '@cue/map/core';

@Directive({
  selector: '[cueDeclarativeMapBase]',
})
export class DeclarativeMapBase {
  identifier: ElementIdentifier = crypto.randomUUID();
  adapter = inject(DECLARATIVE_MAP_IMPLEMENTATION);
}
